import React from 'react';
import VehicleMap from './components/VehicleMap';

function App() {
  return <VehicleMap />;
}

export default App;
